module.exports = __webpack_public_path__ + "img/38_1.298300a0.png";